import { render, staticRenderFns } from "./Box15.vue?vue&type=template&id=58f29483&scoped=true&"
import script from "./Box15.vue?vue&type=script&lang=js&"
export * from "./Box15.vue?vue&type=script&lang=js&"
import style0 from "./Box15.vue?vue&type=style&index=0&id=58f29483&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f29483",
  null
  
)

export default component.exports